import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ImgDieter from '../../assets/img/BAY-Jobsuche_desktop-pict-Dieter_Schruefer_039.jpg';
import ImgMagdalena from '../../assets/img/BAY-Jobsuche_desktop-pict-Magdalena_Schoeberl_107.jpg';
import ImgMichael from '../../assets/img/BAY-Jobsuche_desktop-pict-Michael_Weigert_187.jpg';
import ImgMagdalenaMobile from '../../assets/img/BAY-Jobsuche_mobile-pict-Magdalena_Schoeberl_107.jpg';
import ImgDieterMobile from '../../assets/img/BAY-Jobsuche_moible-pict-Dieter_Schruefer_039.jpg';
import ImgMichaelMobile from '../../assets/img/BAY-Jobsuche_mobile-pict-Michael_Weigert_187.jpg';
import InputSearchBoxStyled from './styled';
import { device, sizes } from '../../constants/devices';
import { FilterHeader } from '..';
import { useIsWhichSize } from '../../hooks/useIsWhichSize';
import Carousel from 'react-material-ui-carousel';
import { zIndexLevels } from '../../constants/zIndexLevels';
import { FilterHeaderInputValues } from '../filterHeader/props';

type ImgProps = {
  desktop: string;
  mobile: string;
};

type HeaderProps = {
  refResults: React.RefObject<HTMLDivElement>;
  refFilterHeader: React.RefObject<HTMLDivElement>;
};

export const Header = ({ refResults, refFilterHeader }: HeaderProps) => {
  const { isSmallerScreen, width } = useIsWhichSize();
  const [radius, setRadius] = useState<FilterHeaderInputValues>({
    value: '20',
    isOnInit: true,
  });
  const [geocode, setGeocode] = useState<{ lat: number; lng: number }>({
    lat: 0,
    lng: 0,
  });
  const images: Array<ImgProps> = [
    { desktop: ImgDieter, mobile: ImgDieterMobile },
    { desktop: ImgMagdalena, mobile: ImgMagdalenaMobile },
    { desktop: ImgMichael, mobile: ImgMichaelMobile },
  ];

  return (
    <Box ref={refFilterHeader}>
      <Box position="relative" zIndex="0" sx={{ backgroundColor: '#333' }}>
        <Box
          position="absolute"
          bottom="auto"
          marginTop="80px"
          zIndex={zIndexLevels.headLine}
          sx={{
            [device.small]: {
              marginTop: '3vh',
            },
          }}
        >
          <Box
            textAlign="left"
            color="white"
            marginLeft="150px"
            sx={{
              [device.small]: {
                marginLeft: '16px',
              },
            }}
          >
            <Typography variant="h1" fontWeight={500} letterSpacing="1.44px">
              Tun, was
            </Typography>
            <Typography variant="h1" fontWeight={700} letterSpacing="1.44px">
              wirklich
            </Typography>
            <Typography variant="h1" fontWeight={500} letterSpacing="1.44px">
              <b>wichtig</b> ist.
            </Typography>
          </Box>
        </Box>

        <Box>
          <Carousel
            stopAutoPlayOnHover={false}
            swipe={false}
            indicators={false}
            navButtonsAlwaysInvisible
            height={isSmallerScreen ? '488px' : '688px'}
            sx={{ zIndex: 0 }}
          >
            {images.map((img: ImgProps, index) => (
              <img
                key={index}
                src={
                  width <= sizes.smallWidthImgCarousel
                    ? img.mobile
                    : img.desktop
                }
                alt="Header"
                style={{
                  width: '100%',
                  height: '100%',
                  maxHeight: isSmallerScreen ? '488px' : '688px',
                  minHeight: '254px',
                  objectFit: 'cover',
                }}
              />
            ))}
          </Carousel>
        </Box>

        <InputSearchBoxStyled
          position="relative"
          marginLeft="150px"
          marginRight="150px"
          width="auto"
          bottom="0"
          sx={{
            [device.small]: {
              marginLeft: '16px',
              marginRight: '16px',
              marginBottom: '20px',
            },
          }}
        >
          <Box className="sui-search-box">
            <FilterHeader
              refResults={refResults}
              radius={radius}
              setRadius={setRadius}
              geocode={geocode}
              setGeocode={setGeocode}
            />
          </Box>
        </InputSearchBoxStyled>
      </Box>
    </Box>
  );
};
